import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  let errorMessage = 'Something went wrong.';
  try {
    const parsed = JSON.parse(error.message);
    if (parsed.error) {
      errorMessage = `Firestore Error: ${parsed.error} (${parsed.operationType} on ${parsed.path})`;
    }
  } catch (e) {
    // Not a JSON error
  }

  return (
    <div className="min-h-screen bg-bg-main flex items-center justify-center p-6">
      <div className="bg-bg-card border border-border-main rounded-2xl p-8 max-w-md w-full text-center space-y-4">
        <h2 className="text-text-main text-lg font-light tracking-widest uppercase">Application Error</h2>
        <p className="text-text-muted text-sm leading-relaxed">{errorMessage}</p>
        <button
          onClick={resetErrorBoundary}
          className="px-6 py-2 bg-bg-input border border-border-secondary rounded-lg text-text-secondary hover:text-text-main transition-all text-xs uppercase tracking-widest"
        >
          Reload Application
        </button>
      </div>
    </div>
  );
};

export const ErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => window.location.reload()}
    >
      {children}
    </ReactErrorBoundary>
  );
};
